import { RootState } from "../../store";

export const getBrandConfig = ({ configuration }: RootState) => {
  return configuration.brand;
};
